var React = require('react');

function Rectangles (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0H708V416H0V0Z","fill":"#009F97","fillOpacity":"0.15","key":0}),React.createElement("path",{"d":"M0 154L708 154V416H0V154Z","fill":"#00C6FF","fillOpacity":"0.36","key":1}),React.createElement("path",{"d":"M0 103H708V416H0V103Z","fill":"#009F97","fillOpacity":"0.25","key":2})]);
}

Rectangles.defaultProps = {"width":"708","height":"416","viewBox":"0 0 708 416","fill":"none"};

module.exports = Rectangles;

Rectangles.default = Rectangles;
